import { Button } from "@/components/catalyst/button";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";

interface Props {
  quarter: number;
  year: number;
  onQuarterChange: (quarter: number, year: number) => void;
}

export function QuarterSelector({ quarter, year, onQuarterChange }: Props) {
  function handlePrevious() {
    if (quarter === 1) {
      onQuarterChange(4, year - 1);
    } else {
      onQuarterChange(quarter - 1, year);
    }
  }

  function handleNext() {
    if (quarter === 4) {
      onQuarterChange(1, year + 1);
    } else {
      onQuarterChange(quarter + 1, year);
    }
  }

  return (
    <div className="flex items-center gap-2">
      <Button color="white" onClick={handlePrevious}>
        <ChevronLeftIcon className="h-4 w-4" />
      </Button>
      <span className="min-w-[120px] text-center text-lg font-semibold">
        Q{quarter} FY{String(year - 1).slice(-2)}/{String(year).slice(-2)}
      </span>
      <Button color="white" onClick={handleNext}>
        <ChevronRightIcon className="h-4 w-4" />
      </Button>
    </div>
  );
}
